module.exports = __webpack_public_path__ + "4f589f4867dbd57eclose.6e40a95e.png";